import { axiosAuthService } from "../axios";



export function checkLogin(userDetails: any) {
    return axiosAuthService.post(`/user/logIn`,{
        "email":userDetails.userId,
        "password":userDetails.password
    }).then((res:any)=>{
        return res?.data;
    }).catch((error:any) => {
        console.log("Error while user login : ", error)
    })
}


export async function getUserSubscription(userName:any)
{
    return await axiosAuthService.post(`user/user_subscription`,{
        "email" : userName
    }).then((res:any)=>{
        return res?.data;
    }).catch((error:any)=>{
        console.log("Error in getUserSubscription : ", error)
        return false;
    })
}

export async function updateUserSession(userName:any, unid:any){
    return await axiosAuthService.post(`user/update_user_session`,{
        "email" : userName,
        "unid" : unid
    }).then((res:any)=>{
        return res?.data;
    }).catch((error:any)=>{
        console.log("Error in getUserSubscription : ", error)
        return false;
    })
}

export async function getUserSession(userName:any){
    return await axiosAuthService.post(`user/loggedin_sessions`,{
        "email" : userName
    }).then((res:any)=>{
        return res?.data;
    }).catch((error:any)=>{
        console.log("Error in getUserSubscription : ", error)
        return false;
    })
}

